import React from "react";

import "./flyoutButton.scss";

export type FlyoutButtonProps = {
    active?: boolean;
    title: string;
    size?: "small" | "large";
    update?: () => void;
};

const FlyoutButton = ({
    active = false,
    title,
    size = "small",
    update,
}: FlyoutButtonProps) => {
    const activeStyle = active ? "flyout-button--active" : "";
    const sizeStyle = size !== "small" ? "flyout-button--big" : "";

    return (
        <div className="d-flex h-100">
            <div
                className={`flyout-button ${activeStyle} ${sizeStyle}`}
                data-test="flyout-button"
            >
                <div
                    tabIndex={0}
                    className="flyout-button__toggle"
                    onClick={() => update && update()}
                >
                    <span>
                        {title}
                        <i className="flyout-button__chevron las la-angle-down" />
                    </span>
                </div>
            </div>
        </div>
    );
};

export { FlyoutButton };
